import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';

const STORAGE_KEY = 'tennis-coach-theme';

export function ThemeToggle({ className }: { className?: string }) {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem(STORAGE_KEY, 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem(STORAGE_KEY, 'light');
    }
  }, [isDark]);

  return (
    <button
      onClick={() => setIsDark((d) => !d)}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={cn(
        'relative p-2 rounded-lg transition-colors',
        className
      )}
    >
      <Sun
        className={cn(
          'w-5 h-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-200',
          isDark ? 'opacity-0 scale-75 rotate-90' : 'opacity-100 scale-100 rotate-0'
        )}
      />
      <Moon
        className={cn(
          'w-5 h-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-200',
          isDark ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 -rotate-90'
        )}
      />
      {/* Invisible spacer */}
      <span className="block w-5 h-5 opacity-0" aria-hidden />
    </button>
  );
}
